import React from "react";
import { paginationLimits } from "../../../common-data/DropdowData";
import { LeftArrowIcon, RightArrowIcon } from "../../../../images/icons/icons";

const PaginationBar = ({
  isPage = 0,
  setIsPage,
  paginationArray = [],
  pageLimit,
  setPageLimit,
}) => {
  const info = paginationArray[0] || {};
  const totalRows = Number(info.pagination) || 0;
  const totalPages = Number(info.pages) || 1;
  const currentLimit = pageLimit;

  const getVisiblePages = () => {
    if (totalPages <= 3) {
      return Array.from({ length: totalPages }, (_, i) => i);
    }
    if (isPage <= 1) {
      return [0, 1, 2];
    }
    if (isPage >= totalPages - 2) {
      return [totalPages - 3, totalPages - 2, totalPages - 1];
    }
    return [isPage - 1, isPage, isPage + 1];
  };
  const visiblePages = getVisiblePages();

  return (
    <div className="custom-pagination-bar">
      <div className="custom-pagination-flex">
        <div className="custom-pagination-structure">
          {/* <span>
            Showing Page <b>{isPage + 1}</b> of <b>{totalPages}</b>
          </span> */}
          <span className="custom-pagination-total">
            Total: <b style={{ color: "#222", fontWeight: 700 }}>{totalRows}</b>
          </span>
        </div>

        <div className="pagination-limit-dropdown">
          <select
            className="custom-pagination-limit improved-pagination-limit"
            value={currentLimit}
            onChange={(e) => {
              e.preventDefault();
              setPageLimit(Number(e.target.value));
              setIsPage(0);
            }}
          >
            {paginationLimits.map((opt) => (
              <option key={opt.value} value={opt.value}>
                {opt.label} / page
              </option>
            ))}
          </select>
        </div>
      </div>

      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 8,
        }}
      >
        <button
          type="button"
          className="custom-pagination-btn improved-pagination-btn"
          onClick={() => setIsPage((p) => Math.max(0, p - 1))}
          disabled={isPage === 0}
        >
          <LeftArrowIcon />
          {/* &larr; Previous */}
        </button>
        <b>{isPage + 1}</b> of <b>{totalPages}</b>
        {/* {visiblePages[0] > 0 && <span className="pagination-dots">...</span>}

        {visiblePages.map((num) => (
          <button
            key={num}
            className={
              num === isPage
                ? "custom-pagination-btn pagination-num improved-pagination-btn active-page-btn"
                : "custom-pagination-btn pagination-num improved-pagination-btn"
            }
            onClick={() => setIsPage(num)}
          >
            {num + 1}
          </button>
        ))}

        {visiblePages[2] < totalPages - 1 && (
          <span className="pagination-dots">...</span>
        )} */}
        <button
          type="button"
          className="custom-pagination-btn improved-pagination-btn"
          onClick={() => setIsPage((p) => Math.min(totalPages - 1, p + 1))}
          disabled={isPage >= totalPages - 1}
        >
          <RightArrowIcon />
          {/* Next &rarr; */}
        </button>
      </div>
    </div>
  );
};

export default PaginationBar;
